import { MouseEventHandler, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { useAccountRolesSelector } from 'src/store';

import { ASIDE_MENU_ROW_CLASS_NAME } from '../aside/Aside';

import { AsideItemRow } from './components';

import styles from './AsideItem.module.scss';


export type TAsideItem = {
	text?: string;
	icon?: string;
	href?: string;
	includes?: string[];
	permission?: string;
	scroll?: number;
	onClick?: MouseEventHandler<HTMLElement>;
};

export function AsideItem(props: TAsideItem) {
	const permissions = useAccountRolesSelector();

	const { pathname } = useLocation();

	const {
		icon = 'icon-home',
		includes = [],
		text = 'Default',
		permission,
		href = '',
	} = props;

	const isActive = useMemo(() => {
		const isActiveItem = includes.find(item => {
			return item === pathname || pathname.split('/').includes(item);
			// if (item === pathname) {
			// 	return true;
			// }

			// const pathnameArr = pathname.split('/').filter(item => item.length > 1);
			// const itemArr = item.split('/').filter(item => item.length > 1);

			// const result = itemArr.find(item => pathnameArr.includes(item));

			// return result;
		});

		return !!isActiveItem;
	}, [pathname, includes]);

	if (permission) {
		if (!permissions.includes(permission)) {
			return (
				<></>
			);
		}
	}

	const classNameParentBox = ASIDE_MENU_ROW_CLASS_NAME;
	const classNames = [classNameParentBox, styles.box];

	if (isActive) {
		classNames.push(styles.active);
	}

	return (
		<div className={ classNames.join(' ') }>
			<AsideItemRow
				text={ text }
				icon={ icon }
				value={ isActive }
				href={ href }
			/>
		</div>
	);
}
